import apiService from "./apiService";

export const getStatus = async () => {
  return apiService.get("/status");
};

export const getNetworks = async () => {
  return apiService.get("/networks");
};
